import { googleApiKey } from '~/config/google'
import { GoogleGeolocationCoordinates } from '~/types/location/GoogleGeolocationCoordinates'

import Service from './Service'

class GeolocationService extends Service {
  constructor () {
    super('https://www.googleapis.com/geolocation/v1/')
  }

  public async getLocation (): Promise<GoogleGeolocationCoordinates> {
    const response = await this.request(`geolocate?key=${googleApiKey}`, {
      method: 'POST',
    })

    return response.status === 200 ? await response.json() : await Promise.reject(response)
  }
}

export default new GeolocationService()
